/*
 *
 * OtpErrorToast
 *
 * @version 1.0.0
 * @author Pietro Bertuccelli
 * @since 20-Jan-2025
*/

import OtpErrorToast from './OtpErrorToastContainer'

export default OtpErrorToast
